// fetch.js

import values from "lodash/values";

import {
  apiCredentials,
  getBasicAuthHeader,
  getCSRFTokenHeader,
} from "../../utils/auth";

const api = apiCredentials();

export const getOptions = (headers = {}) => {
  return {
    method: "GET",
    headers: {
      Authorization: getBasicAuthHeader(),
      ...headers,
    },
  };
};

export const postOptions = body => {
  return {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      Authorization: getBasicAuthHeader(),
      "Content-Type": "application/json",
    },
  };
};

export const putOptions = body => {
  return {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": getCSRFTokenHeader(),
    },
    body: JSON.stringify(body),
  };
};

// https://github.com/github/fetch/issues/256#issuecomment-241613757
export const encodeUrl = (url, parameters = {}) => {
  const esc = window.encodeURIComponent;
  const query = Object.keys(parameters)
    .map(k => esc(k) + "=" + esc(parameters[k]))
    .join("&");
  return `${url}?${query}`;
};

const parseResponse = response => {
  return response.json().then(json => ({
    ok: response.ok,
    json,
  }));
};

const handleSuccessfulFetchAndParse = ({ ok, json }) => {
  if (!ok) {
    throw json;
  } else {
    return json;
  }
};

const handleUnexpectedError = () => {
  throw Error("Something unexpected has occurred. Please wait and try again.");
};

/**
 *  http://stackoverflow.com/a/37099629/246102
 */
const fetchWrapper = (url, options) => {
  return fetch(url, options)
    .then(parseResponse)
    .then(handleSuccessfulFetchAndParse, handleUnexpectedError);
};

export const getWithStatusCheck = url => {
  return fetchWrapper(api.uri + url, getOptions());
};

export const postWithStatusCheck = (url, body) => {
  return fetchWrapper(api.uri + url, postOptions(body));
};

export const mapErrors = response => {
  const message = response["message"];

  if (typeof message === "string") {
    return [message];
  }

  if (typeof message === "object") {
    return values(message);
  }
};
